import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MockLocalStorageService {
    private store: { [key: string]: string } = {};

    getItem(key: string): string | null {
        return this.store[key] || null;
    }

    setItem(key: string, value: string): void {
        this.store[key] = value;
    }

    clear(): void {
        this.store = {};
    }
}